export default {
    title: 'Paramètres',
    back: 'Retour',
    myProfile: 'Mon profil',
    personalSettings: 'Paramètres personnels',
    notifications: 'Notifications',
    notificationDefaults: 'Notifications par défaut',
    myOrganization: 'Mon organisation',
    organizationDetails: 'Détails de l\'organisation',
    members: 'Membres',
    roles: 'Rôles & Permissions',
    helpSupport: 'Aide & Support',
    helpCenter: 'Centre d\'aide',
    developer: 'Développeur',
    apiTokens: 'Accès API',
    advancedSettings: 'Paramètres avancés',
    dangerZone: 'Zone de danger',
    deleteAccount: 'Supprimer le compte',
    exports: 'Exports',
    mediaPlayers: 'Lecteurs de médias',
    bandwidth: 'Bande passante',
    advertising: 'Publicité',
    partners: 'Partenaires',
    workspaces: 'Espaces',
    ideoCards: 'Fiches Ideos',
}
